<div class="cover-wrapper">
  @if (cover) {
  <img [ngSrc]="cover" class="cover" width="272" height="173" />
  }
</div>
<div class="info">
  <h5 class="country-name t-medium">
    <a [routerLink]="'/country/' + countryCode">{{ countryName }}</a>
  </h5>
  <a [routerLink]="extraLink" [queryParams]="extraLinkQuery" class="extra">
    <un-icon [type]="extraIcon" [theme]="extraIconTheme"></un-icon>
    <span class="country-name">{{ extra }}</span>
  </a>
</div>
